import * as C from '../common/constants';
import InputComponent from './InputComponent';
import { makeStyles, createStyles, StyleRules } from '@mui/styles';
import { COLORS, FONTS, FONT_WEIGHT } from '../common/theme';

interface IProps {
  passedRef: any;
  lng: any;
  label?: string;
  hideSwitch?: boolean;
}

const DATA = [
  {
    placeholder: 'talr',
    safeName: 'talr',
    isSwitchVisible: false,
    isSwitchChecked: false,
    isSwitchDisabled: true,
  },
  {
    placeholder: 'email',
    safeName: 'email',
    isMandatory: true,
    isSwitchVisible: false,
    isSwitchChecked: false,
    isSwitchDisabled: true,
  },
];

const useStyles = makeStyles(
  (theme): StyleRules =>
    createStyles({
      personalStyle: {
        width: 'calc(50% - 4px)',
        padding: '6px 10px',
        marginBottom: '10px',
      },
      subLabelStyle: {
        width: '100%',
        // whiteSpace: 'nowrap',
        margin: '10px 0',
        fontWeight: FONT_WEIGHT.medium,
        fontSize: '16px',
        fontFamily: FONTS.alegreya,
        color: COLORS.appBlue,
      },
      [`@media (max-width: 520px)`]: {
        personalStyle: {
          width: '100%',
          padding: '6px 10px',
          marginBottom: '10px',
        },
      },
    })
);

const SurveyFormPersonalContacts = ({
  passedRef,
  lng,
  label,
  hideSwitch,
}: IProps) => {
  const classes = useStyles();

  const getItems = (options, index) => {
    return (
      <InputComponent
        className={classes.personalStyle}
        placeholder={options.placeholder}
        dataName={options.safeName}
        options={options}
        maxLength={C.MAX_TEXT_INPUT}
        passedRef={passedRef}
        type="text"
        key={index}
        lng={lng}
        // defaultValue={defaultValue}
        hideSwitch={hideSwitch}
      />
    );
  };

  return (
    <>
      {Boolean(label) && <div className={classes.subLabelStyle}>{label}</div>}
      {DATA.map(getItems)}
    </>
  );
};

export default SurveyFormPersonalContacts;
